'use strict';

import { Entity } from '../Entity';

export class UserEnrollmentVendorSession extends Entity {
  protected id;

  protected userId;

  protected ind;

  protected vendor;

  protected request;

  protected response;

  protected sessionCode;

  protected dateTimeCreated;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.sessionCode = data.sessionCode;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getUserId() {
    return this.userId;
  }

  public setUserId(userId) {
    this.userId = userId;

    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;

    return this;
  }

  public getVendor() {
    return this.vendor;
  }

  public setVendor(vendor) {
    this.vendor = vendor;

    return this;
  }

  public getRequest() {
    return this.request;
  }

  public setRequest(request) {
    this.request = request;

    return this;
  }

  public getResponse() {
    return this.response;
  }

  public setResponse(response) {
    this.response = response;

    return this;
  }

  public getSessionCode() {
    return this.sessionCode;
  }

  public setSessionCode(sessionCode) {
    this.sessionCode = sessionCode;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }
}
